import { observer } from 'mobx-react-lite';
import { AudioProps } from '../Organization.props';
import Waveform from './WaveForm';
import { OrganizationPreviewCard } from '../../common/Cards/OrganizationPreviewCard';
export const AudioSection = observer(({ url, isDesktop, title }: AudioProps) => {
  return <OrganizationPreviewCard isDesktop={isDesktop} title={title} >
    <Waveform url={url} />
  </OrganizationPreviewCard>
})